import { Heart, Trash2, X } from 'lucide-react';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from '../components/ui/sheet';
import { Button } from '../components/ui/button';

export const FavoritesSheet = ({ open, onClose, favorites = [], onRemoveFavorite, onAddToCart }) => {
    const handleClose = () => {
        if (onClose) onClose(false);
    };

    return (
        <Sheet open={open} onOpenChange={handleClose}>
            <SheetContent 
                className="w-full sm:max-w-md flex flex-col p-0 h-full"
                data-testid="favorites-sheet"
                showCloseButton={false}
            >
                <SheetHeader className="px-4 py-4 border-b border-stone-200">
                    <div className="flex items-center justify-between">
                        <SheetTitle className="text-xl font-bold text-[#007a3f]">
                            Favoritos
                        </SheetTitle>
                        <button
                            onClick={handleClose}
                            className="p-2 hover:bg-stone-100 rounded-full transition-colors"
                            data-testid="close-favorites-button"
                            aria-label="Cerrar"
                        >
                            <X className="h-5 w-5 text-stone-500" />
                        </button>
                    </div>
                    <SheetDescription className="sr-only">
                        Lista de productos favoritos
                    </SheetDescription>
                </SheetHeader>

                {favorites.length === 0 ? (
                    <div className="flex-1 flex flex-col items-center justify-center py-16 px-4 text-center">
                        <div className="w-20 h-20 bg-stone-100 rounded-full flex items-center justify-center mb-4">
                            <Heart className="h-10 w-10 text-stone-400" />
                        </div>
                        <h3 className="text-lg font-semibold text-stone-700 mb-2">
                            Sin favoritos
                        </h3>
                        <p className="text-sm text-stone-500 max-w-xs">
                            Tocá el corazón en los productos para guardarlos aquí
                        </p>
                    </div>
                ) : (
                    <div className="flex-1 overflow-auto p-4">
                        {favorites.map(product => (
                            <div 
                                key={product.product_id}
                                className="flex gap-3 p-3 border-b border-stone-100 last:border-0"
                            >
                                <img
                                    src={product.foto || '/placeholder.png'}
                                    alt={product.nombre}
                                    className="w-16 h-16 rounded-lg object-cover bg-stone-100"
                                />
                                <div className="flex-1">
                                    <h4 className="font-semibold text-stone-900 text-sm line-clamp-2">
                                        {product.nombre}
                                    </h4>
                                    <Button
                                        size="sm"
                                        className="mt-2 h-8 text-xs bg-[#007a3f] hover:bg-[#006633]"
                                        onClick={() => onAddToCart?.(product)}
                                    >
                                        Agregar al carrito
                                    </Button>
                                </div>
                                <button
                                    onClick={() => onRemoveFavorite?.(product.product_id)}
                                    className="p-2 text-stone-400 hover:text-red-500 self-start"
                                >
                                    <Trash2 className="h-4 w-4" />
                                </button>
                            </div>
                        ))}
                    </div>
                )}
            </SheetContent>
        </Sheet>
    );
};
